module.exports = "<div class=oui-skeleton__loader></div> ";